import { Link, NavLink } from "react-router-dom";
import { Menu, X, MessageCircle } from "lucide-react";
import { useState } from "react";
import { useConfig } from "../lib/config";

const links = [
  { to: "/", label: "Ana Sayfa" },
  { to: "/urunler", label: "Ürünler" },
  { to: "/rehber", label: "Rehber" },
  { to: "/hakkimizda", label: "Hakkımızda" },
  { to: "/iletisim", label: "İletişim" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const cfg = useConfig();
  const waLink = cfg.whatsapp
    ? `https://wa.me/${cfg.whatsapp.replace(/\D/g, "")}`
    : "/iletisim";
  return (
    <header
      data-testid="site-navbar"
      className="sticky top-0 z-50 w-full bg-white/80 backdrop-blur-xl border-b border-gray-200"
    >
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" data-testid="navbar-logo" className="flex items-center gap-2">
          <span className="w-8 h-8 bg-[#059669] flex items-center justify-center">
            <span className="text-white font-display text-sm">FD</span>
          </span>
          <span className="font-display text-lg tracking-tight">
            FARDRIVER <span className="text-[#059669]">TÜRKİYE</span>
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-link-${l.to.replace("/", "") || "home"}`}
              className={({ isActive }) =>
                `px-3 py-2 text-sm font-medium transition-colors ${
                  isActive ? "text-[#059669]" : "text-gray-700 hover:text-[#059669]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-2">
          <a
            href={waLink}
            target="_blank"
            rel="noreferrer"
            data-testid="navbar-whatsapp"
            className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] bg-[#059669] text-white px-4 py-2.5 hover:bg-emerald-700 transition-colors"
          >
            <MessageCircle size={14} /> WhatsApp
          </a>
        </div>

        <button
          className="lg:hidden p-2"
          data-testid="navbar-mobile-toggle"
          aria-label="Menüyü aç"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-gray-200 bg-white" data-testid="mobile-menu">
          <div className="px-6 py-3 flex flex-col">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `py-3 text-sm font-medium border-b border-gray-100 ${
                    isActive ? "text-[#059669]" : "text-gray-800"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <a
              href={waLink}
              target="_blank"
              rel="noreferrer"
              onClick={() => setOpen(false)}
              className="mt-4 inline-flex items-center justify-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] bg-[#059669] text-white px-4 py-3"
            >
              <MessageCircle size={14} /> WhatsApp
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
